import { createAction, props } from '@ngrx/store';
import {
  GameQueryParams,
  GameResponse,
} from '@fantaz/shared/data-access/models';

export const initGames = createAction(
  '[Games Page] Init',
  props<{ params: GameQueryParams }>(),
);

export const loadGamesSuccess = createAction(
  '[Games/API] Load Games Success',
  props<{ games: GameResponse }>(),
);

export const loadGamesFailure = createAction(
  '[Games/API] Load Games Failure',
  props<{ error: string }>(),
);

export const filterGamesByTags = createAction(
  '[Games/API] Filter Game By Tags',
  props<{ params: GameQueryParams }>(),
);

export const filterGamesByTagsSuccess = createAction(
  '[Games/API] Filter Game By Tags Success',
  props<{ games: GameResponse }>(),
);

export const filterGamesByTagsFailure = createAction(
  '[Games/API] Filter Game By Tags Failure',
  props<{ error: string }>(),
);

export const clearFilterGamesByTag = createAction(
  '[Games/API] Clear Filter By Tag',
);

export const clearSearchGames = createAction('[Games/API] Clear Search Games');

export const searchGames = createAction(
  '[Games/API Page] Search Games',
  props<{ params: GameQueryParams }>(),
);

export const searchGamesSuccess = createAction(
  '[Games/API Page] Search Games Success',
  props<{ games: GameResponse }>(),
);

export const searchGamesFailure = createAction(
  '[Games/API Page] Search Games Failure',
  props<{ error: string }>(),
);

export const loadMoreGames = createAction(
  '[Games/API Page] Load More Games',
  props<{ params: GameQueryParams }>(),
);

export const loadMoreGamesSuccess = createAction(
  '[Games/API Page] Load More Games Success',
  props<{ games: GameResponse }>(),
);

export const loadMoreGamesFailure = createAction(
  '[Games/API Page] Load More Games Failure',
  props<{ error: string }>(),
);
